<template>
  <div class="w-100">

    <p class="w-100">【{{ ($route.params.uid == 'insert') ? '新增': '修改'}}】折扣區</p>

    <table class="table table-sm table-bordered my__table">
      <tbody>
        <tr>
          <td class="my__table__td">折扣名稱</td>
          <td>
            <b-form-input v-model="discountData.name"></b-form-input>
          </td>
        </tr>
        <tr>
          <td class="my__table__td">
            活動文宣
          </td>
          <td>
            <div class="w-100">
              <b-form-checkbox v-model="discountData.frontWebShow" value="1" unchecked-value="0">
                顯示活動文宣
              </b-form-checkbox>
            </div>

            <div class="w-100">
              <b-form-textarea v-model="discountData.frontWebContent"></b-form-textarea>
            </div>
          </td>
        </tr>
        <tr>
          <td class="my__table__td">使用期間</td>
          <td>
            <div class="w-100">
              <div class="d-flex align-items-center">
                <span>開始時間</span>

                <!-- <b-form-datepicker v-model="discountData.time.startTime"></b-form-datepicker> -->
                <datepicker v-model="discountData.time.startTime" value-type="date" type="date"
                  format="YYYY-MM-DD"></datepicker>
                <datepicker v-model="discountData.time.startTime" type="time" :show-second="false"
                  format="hh:mm"></datepicker>


              </div>
              <div class="d-flex align-items-center">
                <span>結束時間</span>
                <datepicker v-model="discountData.time.endTime" value-type="date" type="date"
                  format="YYYY-MM-DD"></datepicker>
                <datepicker v-model="discountData.time.endTime" type="time" :show-second="false"
                  format="hh:mm"></datepicker>
              </div>

              <ul class="my__table__example__list">
                <li><small class="text-danger">起訖時間會顯示於網頁上，不輸入為永久使用</small></li>
              </ul>

              <b-form-radio-group v-model="discountData.useModel">
                <div class="d-flex align-items-center">
                  <b-form-radio value="inTime">
                    使用期間內才可訂購
                  </b-form-radio>
                  <small>（期間以外時，關閉訂購按鈕）</small>
                </div>

                <div class="d-flex align-items-center">
                  <b-form-radio value="outTime">
                    無論使用期間均可訂購，但非使用期間時<u class="text-danger">無折扣</u>
                  </b-form-radio>
                </div>
              </b-form-radio-group>
            </div>
          </td>
        </tr>
        <tr>
          <td class="my__table__td" rowspan="2">折扣權限</td>
          <td>
            <div class="w-100">
              <div class="d-flex flex-column">
                <small>我該如何選擇？</small>
                <ul class="my__table__example__list">
                  <li>
                    <small>ex 假設本區已設定 <u>買滿 5 件，折價 $500 元</u>、加購 <u>它區加購商品，折價 $100 元</u></small>
                  </li>
                  <li>
                    <small class="text-danger">"購買條件已達標，且有加購商品"</small>
                  </li>
                </ul>
              </div>
              <b-form-radio-group class="d-flex flex-column" v-model="discountData.limitModel">
                <b-form-radio value="payFull">
                  僅使用買滿折扣
                </b-form-radio>

                <small class="text-danger"><u>只折價 $500 元，無視加購折扣</u></small>

                <b-form-radio value="addPurchase">
                  僅使用加購折扣
                </b-form-radio>

                <small class="text-danger"><u>只折價 $100 元，無視買滿折扣</u></small>

                <div class="w-100 d-flex align-items-center">
                  <b-form-radio value="both">
                    買滿及加購折扣功能並存，
                  </b-form-radio>

                  <select class="form-control w-25" v-model="discountData.limitType">
                    <option value="grandTotal">累計制</option>
                    <option value="tallest">折扣高優先</option>
                  </select>
                </div>

                <small class="text-danger" v-if="discountData.limitType=='grandTotal'"><u>買滿折扣 $500
                    + $100 = 共折價 $600 元</u></small>
                <small class="text-danger" v-if="discountData.limitType=='tallest'"><u>買滿折扣 $500 >
                    加購折扣 $100 折價 $500
                    元</u></small>
              </b-form-radio-group>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="d-flex flex-column text-left">
              <div class="w-100">
                <b-form-checkbox v-model="discountData.totalThenDiscount" value="1" unchecked-value="0">
                  <strong
                    :class="'text-' + (discountData.totalThenDiscount ? 'danger' : 'success')">{{ discountData.totalThenDiscount ? "關閉" : "開啟" }}</strong>
                  總價再折扣
                </b-form-checkbox>
                <ul class="my__table__example__list">
                  <li><small>不允許結帳時再對總金額任何折扣</small></li>
                  <li><small>如：總價再折扣或會員等級折扣</small></li>
                </ul>
              </div>

              <div class="w-100">
                <b-form-checkbox v-model="discountData.anyThenDiscount" value="1" unchecked-value="0">
                  <strong
                    :class="'text-' + (discountData.anyThenDiscount ? 'danger' : 'success')">{{ discountData.anyThenDiscount ? "關閉" : "開啟" }}</strong>
                  任何折扣
                </b-form-checkbox>
                <ul class="my__table__example__list">
                  <li><small>以目前售價販賣，關閉範圍包含加購折扣、買滿折扣、會員等級...</small></li>
                </ul>

              </div>
            </div>
          </td>
        </tr>
        <tr v-if="discountData.limitModel!='addPurchase'">
          <td class="my__table__td" rowspan="3">買滿折扣</td>
          <td>
            <div class="w-100">
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="discountData.payFullUse" value="1" unchecked-value="0">
                  使用買滿優惠代碼：</b-form-checkbox>
                <b-input-group class="w-25">
                  <b-form-input class="form-control w-25" v-model="discountData.payFullCode">
                  </b-form-input>
                  <b-input-group-append>
                    <button class="btn btn-sm btn-primary" @click="autoDiscountCode()">自動</button>
                  </b-input-group-append>
                </b-input-group>
                <small>（最少6碼、最多10碼 不分大小寫）</small>
              </div>
              <ul class="my__table__example__list">
                <li><small>消費者如輸入<u class="text-danger">買滿優惠代碼</u>，即可使用下列<u
                      class="text-danger">買滿折扣</u> <strong>（可與其他折扣並存）</strong></small></li>
              </ul>
            </div>

            <!-- <div class="d-flex flex-column text-left">
              <div class="d-flex align-items-center">
                <b-form-checkbox :disabled="dis_temp_data.dis_authority_type === 'showAdd'"  
                  v-model="dis_temp_data.dis_code[0]" :value="true" :unchecked-value="false">
                  使用買滿優惠代號：
                </b-form-checkbox>
                <div>
                  <b-form-input :disabled="dis_temp_data.dis_authority_type === 'showAdd'"
                    v-model="dis_temp_data.dis_code[1]"></b-form-input>
                </div>
                <small>（最多10碼，不分大小寫）</small>
              </div>
              <ul class="">
                <li><small>消費者若輸入買滿優惠代碼，方使用上述買滿折扣，可與其他折扣並存</small></li>
              </ul>
            </div> -->
          </td>
        </tr>
        <tr v-if="discountData.limitModel!='addPurchase'">
          <td>
            <div class="w-100">
              <div class="d-flex align-items-center mb-2">
                <span style="width: 60px">折價條件</span>
                <div style="min-width: 100px">
                  <select class="form-control" v-model="discountData.payFullLimit">
                    <option value="buyCount">購買數量</option>
                    <option value="buyMoney">購買額度</option>
                  </select>
                </div>
                <span style="width: 60px">折價方式</span>
                <div style="width: 100px">
                  <select class="form-control" v-model="discountData.payFullModel">
                    <option value="percentage">折扣</option>
                    <option value="realNumber">折現</option>
                  </select>
                </div>
              </div>

              <div class="d-flex align-items-center mb-2" v-for="(list, index) in 3">
                <div class="d-flex align-items-center">
                  <span>買滿</span>
                  <div>
                    <b-form-input v-model="discountData.payFullDiscount[index].limit">
                    </b-form-input>
                  </div>
                  <span>件，</span>
                </div>

                <div class="d-flex align-items-center"
                  v-if="discountData.payFullModel=='realNumber'">
                  <span>折現</span>
                  <div>
                    <b-form-input v-model="discountData.payFullDiscount[index].value">
                    </b-form-input>
                  </div>
                  <span>元</span>
                </div>

                <div class="d-flex align-items-center"
                  v-if="discountData.payFullModel=='percentage'">
                  <span>打</span>
                  <div>
                    <b-form-select class="form-control" :options="discountRange"
                      v-model="discountData.payFullDiscount[index].value">
                    </b-form-select>
                  </div>
                  <span>折</span>
                </div>
              </div>
              <!-- <div class="d-flex align-items-center">
                <span>買滿</span>
                <div>
                  <b-form-input :disabled="dis_temp_data.dis_authority_type === 'showAdd'"
                    v-model="dis_temp_data.dis_num[1].full_num"></b-form-input>
                </div>
                <div>
                  <select :disabled="dis_temp_data.dis_authority_type === 'showAdd'"
                    class="form-control" v-model="dis_temp_data.dis_num[1].type">
                    <option value="piece">件</option>
                    <option value="dollar">元</option>
                  </select>
                </div>
                <span>，每件</span>
                <div>
                  <select :disabled="dis_temp_data.dis_authority_type === 'showAdd'"
                    v-model="dis_temp_data.dis_type" class="form-control">
                    <option value="discount_price">折價</option>
                    <option value="discount">折扣</option>
                  </select>
                </div>
                <div v-if="dis_temp_data.dis_type === 'discount_price'"
                  class="d-flex align-items-center">
                  <b-form-input :disabled="dis_temp_data.dis_authority_type === 'showAdd'"
                    v-model="dis_temp_data.dis_num[1].discount"></b-form-input>
                  <span>元</span>
                </div>
                <div v-else-if="dis_temp_data.dis_type === 'discount'"
                  class="d-flex align-items-center">
                  <b-form-select :disabled="dis_temp_data.dis_authority_type === 'showAdd'"
                    :options="discountRange" v-model="dis_temp_data.dis_num[0].discount">
                  </b-form-select>
                  <span>折</span>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <span>買滿</span>
                <div>
                  <b-form-input :disabled="dis_temp_data.dis_authority_type === 'showAdd'"
                    v-model="dis_temp_data.dis_num[2].full_num"></b-form-input>
                </div>
                <div>
                  <select :disabled="dis_temp_data.dis_authority_type === 'showAdd'"
                    class="form-control" v-model="dis_temp_data.dis_num[2].type">
                    <option value="piece">件</option>
                    <option value="dollar">元</option>
                  </select>
                </div>
                <span>，每件</span>
                <div>
                  <select :disabled="dis_temp_data.dis_authority_type === 'showAdd'"
                    v-model="dis_temp_data.dis_type" class="form-control">
                    <option value="discount_price">折價</option>
                    <option value="discount">折扣</option>
                  </select>
                </div>
                <div v-if="dis_temp_data.dis_type === 'discount_price'"
                  class="d-flex align-items-center">
                  <b-form-input :disabled="dis_temp_data.dis_authority_type === 'showAdd'"
                    v-model="dis_temp_data.dis_num[2].discount"></b-form-input>
                  <span>元</span>
                </div>
                <div v-else-if="dis_temp_data.dis_type === 'discount'"
                  class="d-flex align-items-center">
                  <b-form-select :disabled="dis_temp_data.dis_authority_type === 'showAdd'"
                    :options="discountRange" v-model="dis_temp_data.dis_num[2].discount">
                  </b-form-select>
                  <span>折</span>
                </div>
              </div> -->
              <ul class="my__table__example__list">
                <li>
                  <small>滿件（元）數量由小到大填寫</small>
                </li>
              </ul>

              <div>
                <b-form-checkbox v-model="discountData.discountMix" value="1" unchecked-value="0">
                  <span class="my__tag text-white"
                    :class="'bg-' + (discountData.discountMix ? 'success' : 'danger')">{{discountData.discountMix ? '可混搭' : '不可混搭'}}</span>相同折扣區內的商品
                </b-form-checkbox>
              </div>

              <div class="d-flex flex-column">
                <small>ex. 此折扣區滿 3 件可折現 $200 <u>購買 A 商品 2 件、購買 B 商品 1 件</u></small>
                <small>
                  <ol class="my__table__example__list">
                    <li>勾選：A 商品 2 件 + B 商品 1 件 = 3 件</li>
                    <li>不勾選：購買 A 商品 或 購買 B 商品 3 件</li>
                  </ol>
                </small>
                <small>※ A 商品 和 B 商品需要屬於相同折扣區才可混搭</small>
              </div>

              <div>
                <b-form-checkbox v-model="discountData.discountFull" value="1" unchecked-value="0">
                  <span class="my__tag text-white"
                    :class="'bg-' + (discountData.discountFull ? 'success' : 'danger')">{{discountData.discountFull ? '允許' : '不允許'}}</span>總價再折扣
                </b-form-checkbox>
              </div>
              <small>不勾選：總價不再打折，訂單細目顯示［不適用總價再折扣］</small>
            </div>
          </td>
        </tr>

        <tr v-if="discountData.limitModel!='addPurchase'">
          <td>
            <b-form-checkbox v-model="discountData.frontFullShow" value="1" unchecked-value="0">
              於購物車 <u>第一步</u> 下方顯示相關商品
            </b-form-checkbox>
          </td>
        </tr>
        <tr v-if="discountData.limitModel!='payFull'">
          <td class="my__table__td" rowspan="3">加購設定</td>
          <td>
            <div class="w-100">
              <div class="d-flex align-items-center mb-1">
                <small class="text-danger mr-2">本區尚未建立任何加購區設定</small>
                <button class="btn btn-primary btn-sm" @click="toExtraSetting()">
                  前往加購區設定
                </button>
              </div>

              <table class="table table-bordered table-sm">
                <tbody>
                  <tr>
                    <td>排序</td>
                    <td>加購區對象</td>
                    <td>折價／折扣</td>
                  </tr>
                  <tr v-for="(add, index) in addPurchaseList">
                    <td>{{ add.index }}</td>
                    <td>{{ add.name }}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

            </div>
          </td>
        </tr>
        <tr v-if="discountData.limitModel!='payFull'">
          <td>
            <div class="d-flex align-items-center">
              <b-form-checkbox v-model="discountData.frontAddPurchaseShow" value="1" unchecked-value="0">
                於購物車 <u>第一步</u> 下方顯示加購商品
              </b-form-checkbox>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="d-flex flex-fill justify-content-center">
      <button class="btn btn-sm btn-outline-primary" @click="saveDiscountSetting()">儲存</button>
      <button class="btn btn-sm btn-outline-secondary ml-2" @click="toFulldis()">返回</button>
    </div>

    <!-- <b-modal id="modal_newDiscount" hide-header centered size="lg">
      <div class="d-flex flex-fill">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th colspan="2">折扣區名稱</th>
              <th>加購區對象</th>
              <th>折價／扣</th>
              <th>金額</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="2"><button v-b-modal.modal_newDiscount2 type="button"
                  class="btn btn-outline-secondary">管理</button>
              </td>
              <td rowspan="2">紅標區</td>
              <td>黃標區</td>
              <td>折價</td>
              <td>＄500元</td>
            </tr>
            <tr>
              <td>藍標區 <span class="border">加購品</span></td>
              <td>折價</td>
              <td>＄2600元</td>
            </tr>
            <tr>
              <td rowspan="2"><button v-b-modal.modal_newDiscount2 type="button"
                  class="btn btn-outline-secondary">管理</button>
              </td>
              <td rowspan="2">黃標區</td>
              <td>紅標區</td>
              <td>折價</td>
              <td>＄500元</td>
            </tr>
            <tr>
              <td>藍標區 <span class="border">加購品</span></td>
              <td>折扣</td>
              <td>9折</td>
            </tr>
            <tr>
              <td><button v-b-modal.modal_newDiscount2 type="button"
                  class="btn btn-outline-secondary">管理</button></td>
              <td>藍標區 <span class="border">加購品</span></td>
              <td>黃標區</td>
              <td>折扣</td>
              <td>9折</td>
            </tr>
            <tr>
              <td><button v-b-modal.modal_newDiscount2 type="button"
                  class="btn btn-outline-secondary">管理</button></td>
              <td>棕標區</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
  import ctrl from "@/js/cartManage/discountSetting";
  export default ctrl;

</script>
